import { getApiPath, getLoginApiPath } from '@/helpers/Utils';

// Encapsulate configuration state
const config = (() => {
  let apiBaseUrl = '';
  let loginApiBaseUrl = '';
  let loaded = false;
  let readyPromise = null;

  // Load and cache API configuration
  async function loadApiConfig() {
    if (loaded) return { apiBaseUrl, loginApiBaseUrl };

    readyPromise = (async () => {
      try {
        const [apiPath, loginPath] = await Promise.all([getApiPath(), getLoginApiPath()]);
        apiBaseUrl = apiPath || '';
        loginApiBaseUrl = loginPath || apiBaseUrl || '';
        loaded = true;
        return { apiBaseUrl, loginApiBaseUrl };
      } catch (error) {
        console.error('Failed to load API configuration:', error.message);
        throw error; // Allow retry on failure
      }
    })();

    return readyPromise;
  }

  // Get primary API base URL
  function getApiBaseUrl() {
    return apiBaseUrl;
  }

  // Get login API base URL
  function getLoginApiBaseUrl() {
    return loginApiBaseUrl;
  }

  // Ensure configuration is ready
  function whenApiConfigReady() {
    if (!readyPromise) {
      readyPromise = loadApiConfig();
    }
    return readyPromise;
  }

  return {
    loadApiConfig,
    getApiBaseUrl,
    getLoginApiBaseUrl,
    whenApiConfigReady,
  };
})();

export const {
  loadApiConfig,
  getApiBaseUrl,
  getLoginApiBaseUrl,
  whenApiConfigReady,
} = config;